export default __webpack_public_path__ + "assets/models/c1f12034274b6e9f4528da967affc312.glb";